import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { sdClient } from 'contexts/SDKClientContext';
import { GetFileFromLibraryResult } from '../hooks/useFileFromLibrary';

// See Prometheus' Shared.PrometheusConstants.MaxUploadFilenameLength
const maxNameLength = 223;

const validate = (val: string | undefined) => {
    if (val && val.length > maxNameLength) {
        return `Name must be ${maxNameLength} characters or less`;
    }
    return undefined;
};

export type FileDetailsNameProps = Readonly<{
    file: GetFileFromLibraryResult;
    canEdit: boolean;
    refetchFile: () => void;
    refreshTable: () => void;
}>;

export function FileDetailsNameEditor({
    file,
    canEdit,
    refetchFile,
    refreshTable,
}: FileDetailsNameProps) {
    const onConfirm = async (updatedName: string | undefined) => {
        if (!updatedName) {
            throw new Error('Attempted to save a file without a name');
        }
        try {
            await sdClient
                .renameFile({
                    identifier: file.Id,
                    newName: updatedName,
                })
                .then(refetchFile)
                .then(refreshTable);
        } catch {
            return 'Unable to save name for File';
        }
        return undefined;
    };

    return (
        <TextInlineEditor
            valueClass="word-break"
            editorStyle={{ width: '50rem' }}
            isDisabled={!canEdit}
            value={file.Name}
            validate={validate}
            onConfirm={onConfirm}
        />
    );
}
